import React, { useState } from 'react';
import { View, Text } from 'react-native';

import {
  DownloadButton,
  downloadReport,
} from 'app/src/elements/ReportDownload';

import { cardStyles as styles } from './index';

const IfSalesReport = ({ data }) => {
  const [buyerId, setBuyerId] = useState();
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'if-sales-report',
      params: { 'buyer-id': buyerId, 'sellerId': sellerId }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>If Sales Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select style={styles.select} onChange={(e) => setSellerId(e.target.value)}>
        <option value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Buyer:</Text>
      <select style={styles.select} onChange={(e) => setBuyerId(e.target.value)}>
        <option value="">Select Buyer</option>
        {data.buyers?.map(buyer => (
          <option key={buyer.id} value={buyer.id}>
            {buyer.fullDisplayName}
          </option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default IfSalesReport;
